// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"App_mainContainer__2o5r7","row2":"App_row2__1RFXW","intro":"App_intro__32qgl"};